"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsubscribeErrors = exports.MailgunErrors = exports.WeatherErrors = exports.AlertErrors = exports.RemoveInterfaceErrors = exports.ChangeEmailErrors = exports.ChangePasswordErrors = exports.TrackingErrors = exports.ResetPasswordErrors = exports.GraphQLErrors = exports.PadErrors = exports.StatusErrors = exports.CountErrors = exports.EventErrors = exports.ZoneErrors = exports.OrganizationErrors = exports.AuthErrors = exports.OpenApiErrors = void 0;
var OpenApiErrors;
(function (OpenApiErrors) {
    OpenApiErrors["NO_CREDITS_LEFT"] = "You have used up all your api credits, try again in 1 minute.";
    OpenApiErrors["NO_OPEN_API_SETUP"] = "Your account hasn't been set up to use the Open API, please contact Technis.";
})(OpenApiErrors = exports.OpenApiErrors || (exports.OpenApiErrors = {}));
var AuthErrors;
(function (AuthErrors) {
    AuthErrors["API_KEY_EXPECTED"] = "This key is invalid, it hasn't been made to be used with the Open API.";
    AuthErrors["API_KEY_DELETED"] = "This Open API key is not usable anymore.";
    AuthErrors["API_NOT_ALLOWED"] = "You are not allowed to use the Open API.";
    AuthErrors["BAD_CREDENTIALS"] = "Wrong email/password.";
    AuthErrors["INVALID_TOKEN"] = "Token is invalid.";
    AuthErrors["NOT_AUTHORIZED"] = "You're not authorized to perform this action";
    AuthErrors["NOT_VALID_USER"] = "The user cannot be found.";
    AuthErrors["TOKEN_EXPECTED"] = "This token is invalid, it has been made to be used with the Open API.";
    AuthErrors["TOKEN_EXPIRED"] = "Your token has expired, please get a new one.";
    AuthErrors["NO_OPEN_API_SETUP"] = "Your account hasn't been set up to use the Open API, please contact Technis.";
    AuthErrors["STOP_N_GO_DELETED"] = "This Stop&Go token is not usable anymore.";
    AuthErrors["STOP_N_GO_EXPIRED"] = "You are using a temporary token that has expired and has been deactivated.";
    AuthErrors["OTP_CODE_EXPECTED"] = "OTP is enabled, please login with the code sent to you.";
    AuthErrors["INVALID_OTP"] = "OTP code invalid.";
})(AuthErrors = exports.AuthErrors || (exports.AuthErrors = {}));
var OrganizationErrors;
(function (OrganizationErrors) {
    OrganizationErrors["NAME_ALREADY_IN_USE"] = "The organization name is already used";
    OrganizationErrors["ORGANIZATION_NOT_FOUND"] = "The organization couldn't be found";
})(OrganizationErrors = exports.OrganizationErrors || (exports.OrganizationErrors = {}));
var ZoneErrors;
(function (ZoneErrors) {
    ZoneErrors["CONTAINS_CHILDREN"] = "The zone still contains children";
    ZoneErrors["ZONE_NOT_FOUND"] = "The zone couldn't be found";
})(ZoneErrors = exports.ZoneErrors || (exports.ZoneErrors = {}));
var EventErrors;
(function (EventErrors) {
    EventErrors["EVENT_NOT_FOUND"] = "The event couldn't be found";
})(EventErrors = exports.EventErrors || (exports.EventErrors = {}));
var CountErrors;
(function (CountErrors) {
    CountErrors["COUNT_NOT_FOUND"] = "No count found for the date";
})(CountErrors = exports.CountErrors || (exports.CountErrors = {}));
var StatusErrors;
(function (StatusErrors) {
    StatusErrors["UNKWOWN_STATUS"] = "This status code is not attributed";
})(StatusErrors = exports.StatusErrors || (exports.StatusErrors = {}));
var PadErrors;
(function (PadErrors) {
    PadErrors["PAD_NOT_LINKED"] = "This pad should be linked to perform this action";
    PadErrors["PAD_CONFIG_NOT_FOUND"] = "The pad doesn't exist in the db";
})(PadErrors = exports.PadErrors || (exports.PadErrors = {}));
var GraphQLErrors;
(function (GraphQLErrors) {
    GraphQLErrors["BAD_REQUEST"] = "Bad Request";
})(GraphQLErrors = exports.GraphQLErrors || (exports.GraphQLErrors = {}));
var ResetPasswordErrors;
(function (ResetPasswordErrors) {
    ResetPasswordErrors["THERE_IS_NO_USER_WITH_THIS_EMAIL"] = "There is no user with email";
    ResetPasswordErrors["RESET_TOKEN_NOT_FOUND"] = "Reset token not found";
    ResetPasswordErrors["PASSWORD_IS_ALREADY_RESETED"] = "Password is already reset";
    ResetPasswordErrors["PASSWORD_RESET_TIME_EXPIRED"] = "Password reset time expired";
    ResetPasswordErrors["INVALID_RESET_PASSWORD_TOKEN"] = "Reset Password token is invalid.";
})(ResetPasswordErrors = exports.ResetPasswordErrors || (exports.ResetPasswordErrors = {}));
var TrackingErrors;
(function (TrackingErrors) {
    TrackingErrors["SESSION_PROJECT_ID_REQUIRED"] = "Session or project id is required.";
    TrackingErrors["ID_REQUIRED"] = "Id is required.";
    TrackingErrors["ACTION_NOT_FOUND"] = "Action with this id not found.";
    TrackingErrors["SESSION_ID_REQUIRED"] = "Session Id is required.";
    TrackingErrors["SOCKET_NOT_INITIALIZED"] = "Socket connection is not established successfully.";
})(TrackingErrors = exports.TrackingErrors || (exports.TrackingErrors = {}));
var ChangePasswordErrors;
(function (ChangePasswordErrors) {
    ChangePasswordErrors["INVALID_PASSWORD"] = "The password is invalid or the user does not have a password.";
    ChangePasswordErrors["TOO_MANY_ATTEMPTS"] = "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.";
    ChangePasswordErrors["TOO_SHORT"] = "Password should contain at least 8 characters";
    ChangePasswordErrors["POLICY"] = "Password should contain at least one letter, one number and one special character";
})(ChangePasswordErrors = exports.ChangePasswordErrors || (exports.ChangePasswordErrors = {}));
var ChangeEmailErrors;
(function (ChangeEmailErrors) {
    ChangeEmailErrors["EMAIL_IS_ALREADY_IN_USE"] = "The email address is already in use by another account.";
})(ChangeEmailErrors = exports.ChangeEmailErrors || (exports.ChangeEmailErrors = {}));
var RemoveInterfaceErrors;
(function (RemoveInterfaceErrors) {
    RemoveInterfaceErrors["ONLY_ONE_INTERFACE_IS_LEFT"] = "Impossible to delete the last interface of the organization";
    RemoveInterfaceErrors["INTERFACE_NOT_FOUND"] = "Interface not found";
})(RemoveInterfaceErrors = exports.RemoveInterfaceErrors || (exports.RemoveInterfaceErrors = {}));
var AlertErrors;
(function (AlertErrors) {
    AlertErrors["NAME_REQUIRED"] = "name field is required";
    AlertErrors["ORGANIZATION_ID_REQUIRED"] = "organizationId field is required";
    AlertErrors["INVALID_CONDITION_TYPE"] = "Condition type is invalid";
    AlertErrors["EVENT_ID_REQUIRED"] = "condition.eventId field is required";
    AlertErrors["CONDITION_VALUE_REQUIRED"] = "condition.value field is required";
    AlertErrors["KINDS_REQUIRED"] = "condition.kinds field is required";
    AlertErrors["DIRECTION_REQUIRED"] = "condition.direction field is required";
    AlertErrors["STATUS_CONDITION_DEVICE_ERROR"] = "Status condition must have at least one device";
    AlertErrors["PAD_STATUS_CODES_REQUIRED"] = "condition.padStatusCodes field is required";
    AlertErrors["CONDITION_MIN_REQUIRED"] = "condition.min field is required";
    AlertErrors["CONDITION_MAX_REQUIRED"] = "condition.max field is required";
    AlertErrors["MIN_MAX_ERROR"] = "condition.min must be less than condition.max";
    AlertErrors["ZONE_ID_REQUIRED"] = "condition.zoneId field is required";
    AlertErrors["INVALID_ACTION_TYPE"] = "Action type is invalid";
    AlertErrors["TITLE_REQUIRED"] = "action.msgTitle field is required";
    AlertErrors["CONTENT_REQUIRED"] = "action.msgContent field is required";
    AlertErrors["PLANNING_CONTACT_ERROR"] = "Planning must have at least one contact";
})(AlertErrors = exports.AlertErrors || (exports.AlertErrors = {}));
var WeatherErrors;
(function (WeatherErrors) {
    WeatherErrors["MISSING_ACCESS_KEY"] = "You have not supplied an API Access Key. [Required format: access_key=YOUR_ACCESS_KEY]";
    WeatherErrors["ADDRESS_REQUIRED"] = "address is required";
})(WeatherErrors = exports.WeatherErrors || (exports.WeatherErrors = {}));
var MailgunErrors;
(function (MailgunErrors) {
    MailgunErrors["ADDRESS_NOT_FOUND"] = "Error: Address not found in bounces table";
    MailgunErrors["EMPTY_EMAIL_PROVIDED"] = "Error: 404 page not found";
})(MailgunErrors = exports.MailgunErrors || (exports.MailgunErrors = {}));
var UnsubscribeErrors;
(function (UnsubscribeErrors) {
    UnsubscribeErrors["INVALID_TOKEN"] = "Unsubscribe token is invalid.";
})(UnsubscribeErrors = exports.UnsubscribeErrors || (exports.UnsubscribeErrors = {}));
